// removed by extract-text-webpack-plugin
module.exports = {"graphicPage":"graphicPage__1JiHk"};


//////////////////
// WEBPACK FOOTER
// ./components/graphic/style.css
// module id = eTAU
// module chunks = 0